import React from "react";
import { Box, Typography } from "@mui/material";
import { brand } from "../theme";

/**
 * Consistent section heading used across the site.
 * Renders a small overline eyebrow, a bold title, and an optional subtitle,
 * with a short accent underline beneath the title.
 */
const SectionHeading = ({
  eyebrow,
  title,
  subtitle,
  align = "center",
  light = false,
}) => {
  const titleColor = light ? "#ffffff" : brand.navy;
  const subColor = light ? "rgba(255,255,255,0.85)" : brand.slate;

  return (
    <Box
      sx={{
        textAlign: align,
        mb: { xs: 4, md: 6 },
        mx: align === "center" ? "auto" : 0,
        maxWidth: align === "center" ? 760 : "none",
      }}
    >
      {eyebrow && (
        <Typography
          variant="overline"
          sx={{
            color: brand.orange,
            display: "block",
            mb: 1,
            fontSize: "0.8rem",
          }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h3"
        sx={{
          color: titleColor,
          fontSize: { xs: "1.7rem", sm: "2.1rem", md: "2.4rem" },
          mb: subtitle ? 2 : 1.5,
        }}
      >
        {title}
      </Typography>
      <Box
        sx={{
          width: 64,
          height: 4,
          borderRadius: 4,
          background: `linear-gradient(90deg, ${brand.blue}, ${brand.orange})`,
          mx: align === "center" ? "auto" : 0,
          mb: subtitle ? 2.5 : 0,
        }}
      />
      {subtitle && (
        <Typography
          variant="body1"
          sx={{
            color: subColor,
            fontSize: { xs: "0.98rem", md: "1.08rem" },
            maxWidth: 680,
            mx: align === "center" ? "auto" : 0,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default SectionHeading;
